import { Box, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'

export const Root = styled(Box)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  background: 'white',
  [theme.breakpoints.up('mobile')]: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    background: theme.tokens.ThemeColorCommonBackground,
    padding: theme.spacing(3),
  },
}))

export const Content = styled(Stack)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('mobile')]: {
    alignItems: 'center',
    marginBlock: 'auto',
    gap: theme.spacing(1.5),
  },
}))

export const Paper = styled(Stack)(({ theme }) => ({
  background: 'white',
  [theme.breakpoints.down('mobile')]: {
    overflow: 'auto',
    flexDirection: 'column-reverse',
  },
  [theme.breakpoints.up('mobile')]: {
    width: '100%',
    maxWidth: '802px', // Figma ignores borders when calculating max width: 800px
    minHeight: '580px',
    borderRadius: theme.spacing(1),
    flexDirection: 'row-reverse',
    border: `1px solid ${theme.tokens.ThemeColorCommonOutline}`,
  },
}))

export const Main = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(4),
  padding: theme.spacing(4, 3, 10),
  [theme.breakpoints.up('mobile')]: {
    width: '100%',
    padding: theme.spacing(4, 3),
  },
  '* + &': {
    padding: theme.spacing(3),
    width: 'auto',
  },
}))

export const Secondary = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(3),
  [theme.breakpoints.down('mobile')]: {
    borderTop: `1px solid ${theme.tokens.ThemeColorCommonOutline}`,
  },
  [theme.breakpoints.up('mobile')]: {
    borderLeft: `1px solid ${theme.tokens.ThemeColorCommonOutline}`,
  },
}))

export const Footer = styled(Box)(({ theme }) => ({
  display: 'none',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(2),
  color: theme.tokens.ThemeColorCommonOnSurfaceTertiary,
  [theme.breakpoints.up('mobile')]: {
    display: 'flex',
  },
}))
